import axios from "axios";
import authHeader from '../Authentification/authHeader';

const url = process.env.REACT_APP_API_URL
const user = JSON.parse(localStorage.getItem('user'));
const role=user?.result?.role_code


export async function getVisitReports(
    datedebut,
    datefin,
    user_code = 'all'
) {
    try {
        return await axios.get(
            `${url}rapports/visitReports/${datedebut}/${datefin}/${user_code}`,
            { headers: authHeader() }
        );
    } catch (error) {
        console.error(error);
        return error.response;
    }
}

/** Détail complet d'un rapport. */
export async function getVisitReportDetails(id) {
    try {
        return await axios.get(`${url}rapports/visitReports/details/${id}`, { headers: authHeader() })
    } catch (error) {
        console.error(error)
        return error.response
    }
}

/** Commerciaux ayant au moins un rapport (pour le filtre). */
export async function getVisitReportUsers() {
    try {
        return await axios.get(`${url}rapports/visitReports/users`, { headers: authHeader() })
    } catch (error) {
        console.error(error)
        return error.response
    }
}